import React from 'react';
import propTypes from 'prop-types';
import { getEligibleDeals, getTotalDealValue } from './Checkout/helpers';
import { productPropType } from '../ProductSearch/helpers/productPropType';

const DealList = ({ deals, showFreeAlignment = false }) => {
  if (!deals.length && !showFreeAlignment) {
    return null;
  }

  return (
    <>
      {deals.map((deal) => (
        <li key={deal.id}>{deal.marketing_summary}</li>
      ))}
    </>
  );
};

const fullSetPrice = (product) => {
  let totalPrice = 0;
  const { pricingGroup } = window.drupalSettings.storeDetails;

  if (product.splitFitment) {
    const frontTireUnitPrice = parseFloat(product.frontTire.productDetails.price[pricingGroup]);
    const rearTireUnitPrice = parseFloat(product.rearTire.productDetails.price[pricingGroup]);
    totalPrice = (2 * frontTireUnitPrice) + (2 * rearTireUnitPrice);

    const instantSavings = getTotalDealValue(product.frontTire.deals, 'instant', 4, totalPrice);
    totalPrice -= instantSavings;
  } else {
    const tireUnitPrice = product.productDetails.price[pricingGroup];
    totalPrice = 4 * tireUnitPrice;

    const instantSavings = getTotalDealValue(product.deals, 'instant', 4, totalPrice);
    totalPrice -= instantSavings;
  }

  return totalPrice;
};

const Deals = ({
  deals,
  isTrailerTire,
  product,
}) => {
  const originalPrice = fullSetPrice(product);

  // filter out deals that don't match the discount thresholds
  // const eligibleRebates = getEligibleDeals(deals, 'rebate', 4, originalPrice);
  // const eligibleInstantDiscounts = getEligibleDeals(deals, 'instant', 4, originalPrice);

  // const eligibleDeals = eligibleRebates.concat(eligibleInstantDiscounts);
  const eligibleDeals = getEligibleDeals(deals, null, 4, originalPrice);

  return (
    <>
      <h3 className="cmp-quote__heading">Deals</h3>
      <div className="cmp-quote-deals">
        <h4>
          Special Deals:
        </h4>
        <ul>
          {!isTrailerTire && <DealList deals={[]} showFreeAlignment />}
          <DealList deals={eligibleDeals} />
        </ul>
      </div>
    </>
  );
};

const dealsPropType = propTypes.arrayOf(propTypes.shape({
  id: propTypes.number,
  title: propTypes.string,
  marketing_description: propTypes.string,
  discount: propTypes.oneOfType([
    propTypes.string,
    propTypes.shape({
      type: propTypes.string,
    }),
  ]),
}));

DealList.propTypes = {
  deals: dealsPropType,
  showFreeAlignment: propTypes.bool,
};

Deals.propTypes = {
  deals: dealsPropType,
  isTrailerTire: propTypes.bool,
  product: productPropType,
};

export { Deals };
